import Actions from 'actions';

const initialState = Object.freeze({});

function optOut(state = initialState, action) {
  switch (action.type) {
    case Actions.OPT_OUT_EVENT_REQUEST:
      return initialState;
    case Actions.OPT_OUT_EVENT_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.OPT_OUT_EVENT_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default optOut;
